import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import firebase from 'firebase';
import { useHistory } from 'react-router-dom';
import './styles.css';

const Auth = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const { authType } = useParams();
    const history = useHistory();

    const onPressSubmit = (event) => {
        event.preventDefault();
        console.log(email);
        console.log(password);
        console.log(authType);
        if (authType === 'signUp') {
            firebase.auth().createUserWithEmailAndPassword(email, password).then(() => {
                history.goBack();
            }).catch((error) => {
                alert('You had an error creating an account! ' + error.message);
            });
        } else {
            firebase.auth().signInWithEmailAndPassword(email, password).then(() => {
                history.goBack();
            }).catch((error) => {
                alert('You had an error creating an account! ' + error.message);
            });
        }
    }

    const onClickBack = () => {
        history.goBack();
    }

    return (
        <div className="card">
            <h1 className="authHeader">{`Welcome${authType === 'signUp' ? '' : ' back'}!`}</h1>
            <h2 className="authSubHeader">{`Please enter your email and password to sign ${authType === 'signUp' ? 'up' : 'in'}!`}</h2>
            <form id="form" onSubmit={(event) => onPressSubmit(event)} className="authForm">
                <label className="authLabel">Enter Your Email:</label>
                <input
                    value={email}
                    placeholder="example@example.com"
                    onChange={(input) => { setEmail(input.target.value) }}
                />
                <label className="authLabel">Enter Your Password:</label>
                <input
                    value={password}
                    type="password"
                    onChange={(input) => { setPassword(input.target.value) }}
                />
                <input type="submit" value="Submit" className="submitButton"/>
            </form>
            <div className="goBack">
                <button onClick={() => { onClickBack()}}>
                    Go Back
                </button>
            </div>
        </div>
    );
};

export default Auth;